import React from "react";
import List from "../components/List";

interface ISubmission {
	viewDetailHandler?: any;
}

const Submissions = ({ viewDetailHandler }: ISubmission) => {
	return <List title={"Submissions"} viewDetailHandler={viewDetailHandler} />;
};

export default Submissions;
